<template>
    <div class="imodal scrollable" v-show-delay="value" @click="hide">
        <div class="iwrapper scrollman " :class="{full}"  :style="width?{width:width+'px',position:'fixed', marginLeft:-(width/2)+'px', left:'50%'}:{}">
            <slot/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "imodal",
        props:{
            "width":{
                type:String,
                default:""
            },
            "shown":{
                type:Boolean,
                default:false
            },
            "value":{
                type:Boolean,
                default:false
            },
            "full":{
                type:Boolean,
                default:false
            }
        },
        computed: {},
        methods: {
            hide(){
                if(event.target.classList.contains('imodal')){
                this.$emit('input',false);

                }
                event.stopPropagation();
                //e.stopPropagation();
                //e.preventDefault();
            }
        }
    }
</script>

<style scoped>
    .imodal {
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(51, 138, 255, 0);
        top: 0;
        left: 0;
        transition: 0.4s background ease;
        z-index:99999;
    }

    .imodal.shown{
        background: rgba(51, 138, 255, 0.3);
    }
    .imodal.shown .iwrapper{
        transform: translateY(0%);
    }

    .iwrapper.full{
        width:100%;
        margin:0;
        max-height:100%;
        height:100%;
        border-radius: 0;
        top:0;

    }

    .iwrapper{
        width: 90%;
        top: 10px;
        position: absolute;
        background: white;
        padding: 10px;
        border-radius:10px;
        max-height:90%;
        overflow:auto;
        transform: translateY(1000px);
        transition: 0.4s transform ease;
    }

</style>